module.exports = __webpack_public_path__ + "static/img/top_bg.ecda017a.png";